// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bread__SA7lM {
  margin-bottom: 24px;
}
.bread__SA7lM .ant-breadcrumb {
  display: flex;
  align-items: center;
}
@media (max-width: 767px) {
  .bread__SA7lM {
    margin-bottom: 12px;
  }
}
/*# sourceMappingURL=Bread.module.css.map */`, "",{"version":3,"sources":["webpack://./Bread.module.less","webpack://./src/Components/Breadcrumb/Bread.module.less"],"names":[],"mappings":"AAAA;EACI,mBAAA;ACCJ;ADFA;EAKQ,aAAA;EACA,mBAAA;ACAR;ADKE;EACE;IACE,mBAAA;ECHJ;AACF;AACA,2CAA2C","sourcesContent":[".bread {\n    margin-bottom: 24px;\n  \n    :global {\n      .ant-breadcrumb {\n        display: flex;\n        align-items: center;\n      }\n    }\n  }\n  \n  @media (max-width: 767px) {\n    .bread {\n      margin-bottom: 12px;\n    }\n  }",".bread {\n  margin-bottom: 24px;\n}\n.bread :global .ant-breadcrumb {\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 767px) {\n  .bread {\n    margin-bottom: 12px;\n  }\n}\n/*# sourceMappingURL=Bread.module.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bread": `bread__SA7lM`
};
export default ___CSS_LOADER_EXPORT___;
